import styled from 'styled-components';

export const EquipmentManager = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  flex-basis: auto;
  flex-shrink: 0;
  @media (max-width: 960px) {
    gap: 20px;
    align-items: center;
    justify-content: center;
    padding: 0 20px 20px;
  }
  @media (max-width: 580px) {
    gap: 20px;
    //flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 20px 20px;
  }
`;

export const Content = styled.div`
 /*  display: flex;
  align-items: center;
  height: calc(100% - 111px); */
  flex-grow: 1;
  flex-basis: auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const ButtonsDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  
  &#user-tab__mobile-button {
    display: none;
  }
  @media screen and (max-width: 960px) {
    display: none;
    &#user-tab__mobile-button {
      display: flex;
    }
  }
`;

export const InputDiv = styled.div`
  width: 687px;
  
  @media screen and (max-width: 960px) {
    width: 100%;
  }
`;

export const CompanyName = styled.div`
  letter-spacing: 0.36px;
  font-size: 24px;
  line-height: 24px;
  font-weight: 800;
  margin-bottom: 20px;
  display: flex;
  text-transform: uppercase;
  color: ${props => props.theme.colors.solidButton};
  gap: 8px;
`;

export const Country = styled.div`
  letter-spacing: 0.36px;
  font-size: 13px;
  line-height: 24px;
  font-weight: 500;
  display: flex;
  gap: 8px;

  div {
    font-weight: 400;
  }
`;

export const Map = styled.div`
  display: flex;
  align-items: center;
  font-size : 14px;
  font-weight: 500;
  color: ${(props) => props.theme.colors.solidButton};
  cursor: pointer;
`;

export const ArrowBack = styled.p`
  text-align: left;
  letter-spacing: 0px;
  color: ${props => props.theme.colors.textHeader};
  font-weight: normal;
  font-size: 12px;
  cursor: pointer;
  margin-top: 18px;
  vertical-align: middle;
  display: flex;
  align-items: center;
  text-transform: uppercase;

  svg{
      font-size: 14px;
  }
`;

export const Header = styled.div`
/*  
  //max-height: calc(100vh - 65px);
  height: 100%;
  box-sizing: border-box; */
  padding: 20px;
  @media screen and (max-width: 960px) {
    padding: 0px 20px 0px 20px ;
  }
`;

export const Location = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 200px;
  margin-bottom: 20px;
`;

export const PaginationDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  a {
    text-decoration: none;       
  }
  
  button { 
        color: ${props => props.theme.colors.PaginationColor};
        background-color: ${props => props.theme.colors.PaginationBackground};
        opacity: 0.5;
    }

    
    button[aria-label="Go to previous page"] {
        background: none;
        color: ${props => props.theme.colors.PaginationIcon};
    }

    button[aria-label="Go to next page"] {
        background: none;
        color: ${props => props.theme.colors.PaginationIcon};
    }

    button, a {
        -webkit-tap-highlight-color: transparent;
        outline: none;
        touch-action: manipulation; 
    }

    button:active, a:active {
        background-color: inherit;
        opacity: 1;
        transition: none; 
    }

    .MuiPaginationItem-ellipsis {
        height: auto;
        color: ${props => props.theme.colors.PaginationIcon};
    }

    .MuiPaginationItem-page.Mui-selected {
        background-color: ${props => props.theme.colors.PaginationBackgroundSelect};
        opacity: 1;
    }

    .MuiPaginationItem-page.Mui-selected:hover {
        background-color: ${props => props.theme.colors.PaginationBackgroundSelect};
        opacity: 1;
    }

    .MuiPaginationItem-page:hover {
        background-color: ${props => props.theme.colors.PaginationBackgroundSelect};
        opacity: 1;
        transition: 0.5ms ease-in-out;
    }

  @media screen and (max-width: 960px) {
    padding-top: 10px;
  }
`;

export const TableContent = styled.div`
    flex-grow: 1;
    height: 400px;
    box-sizing: border-box;
    
    @media screen and (max-width: 960px) {
       // height: 80%;
    }
`;

export const InfoDelete = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0px;
    left: 55%;
    transform: translateX(-50%);
    height: 60px;
    padding: 0px 20px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    background: #5DAEFF;
    color: ${props => props.theme.colors.textSecondary};
    z-index: 9;
    @media (max-width: 960px) {
      left: 50%;
      width: 100vw;
    } 
`;

export const DivButton = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: row;
    gap: 20px;
   

    &.optionButtons {
        background-color: ${(props) => props.theme.colors.background};
        position: absolute;
        bottom: 0;
        padding: 20px 0;
        width: 100%;
        left: 56%;
        transform: translateX(-50%);
        @media (max-width: 960px) {
          left: 50%;
          bottom: 50px;
        }   
    }
    
`;
